import type { LinkToCohortCertificateSignature } from '@efdigital/ll-addon-content/types/components/parts/link-to-cohort-certificate';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

const LinkToCohortCertificate: TemplateOnlyComponent<LinkToCohortCertificateSignature> =
  <template>
    <a href="#" ...attributes>{{yield}}</a>
  </template>;

export { LinkToCohortCertificate };
